import * as React from 'react';
import { Campaign } from 'types/ts/campaigns';

type GMSEnabledDetailsProps = {
  model: Campaign & { gmsEnabled?: boolean },
  onModelChange: Function,
  handleInputChange: (event: React.FormEvent<HTMLInputElement>, data: any) => void,
  handleControlBlur: Function,
  error: any,
  hasError: Function,
};

const GMSEnabledDetails: React.FC<GMSEnabledDetailsProps> = () => {
  return null;
};

export default GMSEnabledDetails;
